import React, { useState, useEffect, useRef } from "react";
import ResponseModal from "../modals/ResponseModal";
import MessageBox from "./MessageBox";
import SelectUser from "../users/SelectUser";
import {isMobile} from "react-device-detect";

function PeerTalkRoot(props) {
    const [show, setShow] = useState(false);
    const [selectedExpert, setSelectedExpert] = useState(props.experts[0]);
    const [showSelectUserModal, setShowSelectUserModal] = useState(false);
    const [messageSent, setMessageSent] = useState(false);

    const onHandleCloseResponse = () => {
        setMessageSent(false);
        setShowSelectUserModal(false);
    }

    useEffect(() => {
        if(!isMobile) {
            const timer = setTimeout(() => {
                dataLayer.push({'event': 'PeerTalk_sneakpeek' });
                setShow(true)
            }, 1500);
            return () => clearTimeout(timer);
        }
    }, []);

    useEffect(() => {
        if(showSelectUserModal) {
            dataLayer.push({'event': 'PeerTalk_findanother' });
        }
    }, [showSelectUserModal]);

    const toggleMessageBox = () => {
        setShow(!show);
    }

    const onMessageSent = () => {
        toggleMessageBox();
        setMessageSent(true);
    }

    const onHandleSelectExpert = (user) => {
        setSelectedExpert(user);
        setShowSelectUserModal(false);
    }

    const renderMessageSent = () => {
        if(messageSent) {
            let message = `Thank you for your interest. We will contact you soon to schedule a meeting with ${selectedExpert.username}`;
            return (
                <ResponseModal
                    modalSize={'sm'}
                    bgColor={'white'}
                    textColor={'secondary'}
                    btnColor={'primary'}
                    icon={'check-circle'}
                    header={'Success'}
                    message={message}
                    show={!!messageSent}
                    handleShow={onHandleCloseResponse} />
            )
        }
    }

    const renderSelectUserModal = () => {
        if(showSelectUserModal) {
            return (
                <SelectUser
                    users={props.experts}
                    onSelectUser={onHandleSelectExpert}
                    currentUser={selectedExpert}
                    show={showSelectUserModal}
                    onCancel={setShowSelectUserModal}
                    productName={props.product_name}
                />
            )
        }
    }

    const renderMessageBox = () => {
        return (
            <MessageBox
                productId={props.product_id}
                productName={props.product_name}
                categoryId={props.category_id}
                gdpr={props.gdpr}
                toggleMessageBox={toggleMessageBox}
                show={show}
                selectedExpert={selectedExpert}
                onMessageSent={onMessageSent}
                onToggleExperts={setShowSelectUserModal}
                token={props.token}
            ></MessageBox>
        )
    }

    return (
        <>
            {renderMessageBox()}
            {renderMessageSent()}
            {renderSelectUserModal()}
        </>
    );
}

PeerTalkRoot.displayName = 'PeerTalkRoot';

export default PeerTalkRoot;